/* @flow */
import Reflux from "reflux";

const MainCategoryAction = Reflux.createActions(["loadMainCategories"]);

export default MainCategoryAction;
